import raw from "../data/businessCountryPresets.json";
import { countryCodeToFlagEmoji } from "../utils/countryFlag";

export const BUSINESS_COUNTRY_PRESETS = (raw.countries ?? []).map((c) => ({
  ...c,
  flagEmoji: countryCodeToFlagEmoji(c.countryCode),
}));

function compareCountryPresets(a, b) {
  const rankA = Number(a.sortRank ?? 2);
  const rankB = Number(b.sortRank ?? 2);
  if (rankA !== rankB) return rankA - rankB;
  return String(a.label).localeCompare(String(b.label), "fr");
}

export const BUSINESS_COUNTRY_PRESETS_SORTED = [...BUSINESS_COUNTRY_PRESETS].sort(
  compareCountryPresets
);

export function getCountryPreset(countryCode) {
  const code = String(countryCode ?? "").trim().toUpperCase();
  return (
    BUSINESS_COUNTRY_PRESETS.find((p) => p.countryCode === code) ??
    BUSINESS_COUNTRY_PRESETS[0]
  );
}

export function filterCountryPresets(query) {
  const q = String(query ?? "").trim().toLowerCase();
  if (!q) return BUSINESS_COUNTRY_PRESETS_SORTED;
  return BUSINESS_COUNTRY_PRESETS_SORTED.filter((p) => {
    const label = String(p.label).toLowerCase();
    const code = String(p.countryCode).toLowerCase();
    const cur = String(p.baseCurrency).toLowerCase();
    return label.includes(q) || code.includes(q) || cur.includes(q);
  });
}

export function buildCountryPickerRows(query, sectionTitles) {
  const list = filterCountryPresets(query);
  const out = [];
  let lastRank = null;
  const searching = Boolean(String(query ?? "").trim());
  for (const item of list) {
    const rank = Number(item.sortRank ?? 2);
    if (rank !== lastRank && !searching) {
      if (rank === 0) out.push({ type: "header", key: "h-home", title: sectionTitles.home });
      else if (rank === 1) out.push({ type: "header", key: "h-neighbors", title: sectionTitles.neighbors });
      else if (rank === 2) out.push({ type: "header", key: "h-africa", title: sectionTitles.africa });
      else if (rank === 3) out.push({ type: "header", key: "h-asia", title: sectionTitles.asia });
      lastRank = rank;
    }
    out.push({ type: "country", key: item.countryCode, item });
  }
  return out;
}
